// usePyqRedux.js
import { useSelector, useDispatch } from "react-redux";
import userActivityActions from "../../../../../../../redux/user_activity/action";
import userPyqTestsAction from "../../../../../../../redux/pyq_test_exercises/action";
import PyqDailyChallengeActions from "../../../../../../../redux/pyq_daily_challenge/action";

const usePyqRedux = () => {
  const dispatch = useDispatch();
  const userPreference = useSelector((state) => state.userPreference);
  const pyqMainCurrentTab = useSelector(
    (state) => state.pyqTestsData.pyqMainCurrentTab
  );
  const pyqSubCurrentTab = useSelector(
    (state) => state.pyqTestsData.pyqSubCurrentTab
  );

  const pyqCurrentYear = useSelector(
    (state) => state.pyqTestsData.pyqCurrentYear
  );

  const setPyqTopicData = (payload) =>
    dispatch(userActivityActions.setPyqTopicData(payload));

  const setPyqTopicSubject = (payload) =>
    dispatch(userActivityActions.setPyqTopicSubject(payload));

  const setPyqTestsData = (payload) =>
    dispatch(userPyqTestsAction.setPyqTestsData(payload));

  const setPyqTestsResultData = (payload) =>
    dispatch(userPyqTestsAction.setPyqTestsResultData(payload));

  const setPyqMainCurrentTab = (payload) =>
    dispatch(userPyqTestsAction.setPyqMainCurrentTab(payload));

  const setPyqSubCurrentTab = (payload) =>
    dispatch(userPyqTestsAction.setPyqSubCurrentTab(payload));

  const setPyqCurrentYear = (payload) =>
    dispatch(userPyqTestsAction.setPyqCurrentYear(payload));

  const setDay = (payload) =>
    dispatch(PyqDailyChallengeActions.setDay(payload));

  return {
    userPreference,
    pyqMainCurrentTab,
    pyqSubCurrentTab,
    pyqCurrentYear,
    setPyqTopicData,
    setPyqTopicSubject,
    setPyqTestsData,
    setPyqTestsResultData,
    setDay,
    setPyqMainCurrentTab,
    setPyqSubCurrentTab,
    setPyqCurrentYear,
  };
};

export default usePyqRedux;
